import React from "react";

class EvalSummary extends React.Component {
    static defaultProps = {
        evaluation: null,
        inline: false
    };

    render = () => {
        if ((this.props.evaluation === undefined || this.props.evaluation === null) || 
            ((this.props.evaluation.category === undefined || this.props.evaluation.category === null) &&
            (this.props.evaluation.score === undefined || this.props.evaluation.score === null)))
            return null;

        return (
            <div className={`eval-summary ${this.props.inline ? "inline" : ""}`}>
                <div className="eval-summary-label"><div>{this.props.evaluation.label}</div></div>
                <div style={{ textAlign: "center", background: this.getClass(this.props.evaluation.category) }} colSpan={this.props.evaluation.score === null ? 2 : 1}>
                    {this.props.evaluation.category}
                </div>
                {this.props.evaluation.score && <div style={{ textAlign: "center", background: this.getClass(this.props.evaluation.category) }}>
                    {this.props.evaluation.score.toFixed(2)}
                </div>}
                <div className="eval-summary-desc">{this.props.evaluation.description}</div>
            </div>
        )
    }
    getClass = (label) => {
        switch (label) {
            case "A":
            case "B":
                return "#9fd300";
            case "C":
                return "#ffd200";
            case "D":
            case "E":
                return "#f34454";
            default: return "inherit";
        }
    }
}

export default EvalSummary;